import palette from '../palette';

const fabOverrides = {
  styleOverrides: {
    root: {
      backgroundColor: palette.common.white,
      color: palette.text.secondary,
      '&:hover': {
        backgroundColor: palette.common.neutral,
      },
    },
  },
};

export default fabOverrides;
